export { default as Page } from './lib/SearchPage';
export { getServerSidePropsFor } from './lib/getServerSideProps';
export { hasPathMatch } from './lib/hasPathMatch';
